import React from 'react';

const PrivacyContactSection = () => {
  return (
    <section id="kontakt" style={{ marginBottom: '80px' }}>
      {/* Handcrafted divider */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          marginBottom: '48px'
        }}
      >
        <div style={{ flex: 1, height: '1px', background: 'linear-gradient(90deg, transparent, rgba(249,115,22,0.4))' }} />
        <div
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: '0.75rem',
            color: '#F97316',
            letterSpacing: '0.2em',
            textTransform: 'uppercase'
          }}
        >
          ✦ KONTAKT ✦
        </div>
        <div style={{ flex: 1, height: '1px', background: 'linear-gradient(90deg, rgba(249,115,22,0.4), transparent)' }} />
      </div>
      <div style={{ marginBottom: '40px', position: 'relative' }}>
        <div
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: 'clamp(4rem, 10vw, 8rem)',
            fontWeight: 900,
            color: 'rgba(249,115,22,0.05)',
            lineHeight: 1,
            position: 'absolute',
            top: '-20px',
            left: '-10px',
            userSelect: 'none',
            letterSpacing: '-0.04em'
          }}
        >
          10
        </div>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#F97316',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: '8px'
            }}
          >
            § 10 — KONTAKT OSS
          </div>
          <h2
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(1.75rem, 4vw, 3rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              textTransform: 'uppercase',
              letterSpacing: '-0.02em',
              lineHeight: 1
            }}
          >
            Personvernkontakt
          </h2>
        </div>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: '24px',
          marginBottom: '40px'
        }}
      >
        {/* DPO Card */}
        <div
          style={{
            background: 'rgba(255,255,255,0.02)',
            border: '2px solid rgba(59,111,212,0.2)',
            padding: '32px',
            position: 'relative',
            transform: 'rotate(-0.5deg)'
          }}
        >
          {/* Polaroid tape */}
          <div
            style={{
              position: 'absolute',
              top: '-10px',
              left: '24px',
              width: '50px',
              height: '20px',
              background: 'rgba(59,111,212,0.2)',
              border: '1px solid rgba(59,111,212,0.3)',
              transform: 'rotate(2deg)'
            }}
          />
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.625rem',
              color: '#3B6FD4',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              marginBottom: '12px'
            }}
          >
            PERSONVERNOMBUD (DPO)
          </div>
          <div
            style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: '1.125rem',
              fontWeight: 800,
              color: '#EEF0F2',
              marginBottom: '16px'
            }}
          >
            NordPass AS
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {[
              { label: 'E-post', value: 'hei@nordpassno.com', href: 'mailto:hei@nordpassno.com' },
              { label: 'Telefon', value: '+47 20 94 89 03', href: 'tel:+4720948903' },
            ]?.map((item, i) => (
              <div key={i}>
                <div
                  style={{
                    fontFamily: 'JetBrains Mono, monospace',
                    fontSize: '0.5625rem',
                    color: 'rgba(138,149,163,0.4)',
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                    marginBottom: '2px'
                  }}
                >
                  {item?.label}
                </div>
                <a
                  href={item?.href}
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '0.875rem',
                    color: '#3B6FD4',
                    textDecoration: 'none'
                  }}
                >
                  {item?.value}
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Postal address card */}
        <div
          style={{
            background: 'rgba(255,255,255,0.02)',
            border: '2px solid rgba(249,115,22,0.2)',
            padding: '32px',
            position: 'relative',
            transform: 'rotate(0.5deg)'
          }}
        >
          {/* Polaroid tape */}
          <div
            style={{
              position: 'absolute',
              top: '-10px',
              right: '24px',
              width: '50px',
              height: '20px',
              background: 'rgba(249,115,22,0.2)',
              border: '1px solid rgba(249,115,22,0.3)',
              transform: 'rotate(-2deg)'
            }}
          />
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.625rem',
              color: '#F97316',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              marginBottom: '12px'
            }}
          >
            POSTADRESSE
          </div>
          <div
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: '0.9375rem',
              color: 'rgba(238,240,242,0.75)',
              lineHeight: 2,
              fontStyle: 'normal'
            }}
          >
            <div style={{ fontFamily: 'Syne, sans-serif', fontStyle: 'normal', fontWeight: 700, color: '#EEF0F2', fontSize: '1rem', marginBottom: '4px' }}>NordPass AS</div>
            <div>v/ Personvernombud</div>
            <div>Karl Johans gate 1</div>
            <div>0154 Oslo</div>
            <div>Norge</div>
            <div style={{ marginTop: '8px', fontFamily: 'JetBrains Mono, monospace', fontSize: '0.75rem', color: 'rgba(138,149,163,0.5)' }}>Org.nr: 123 456 789</div>
          </div>
        </div>

        {/* Datatilsynet card */}
        <div
          style={{
            background: 'rgba(255,255,255,0.02)',
            border: '1px solid rgba(255,255,255,0.06)',
            padding: '32px',
            position: 'relative'
          }}
        >
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.625rem',
              color: 'rgba(138,149,163,0.5)',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              marginBottom: '12px'
            }}
          >
            TILSYNSMYNDIGHET
          </div>
          <div
            style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: '1.125rem',
              fontWeight: 800,
              color: '#EEF0F2',
              marginBottom: '10px'
            }}
          >
            Datatilsynet
          </div>
          <p
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '0.8125rem',
              color: 'rgba(138,149,163,0.7)',
              lineHeight: 1.6,
              marginBottom: '16px'
            }}
          >
            Norsk tilsynsmyndighet for personvern. Du kan klage til Datatilsynet 
            dersom du mener vi behandler dine data i strid med GDPR.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <a href="https://www.datatilsynet.no" target="_blank" rel="noopener noreferrer" style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: '#3B6FD4', textDecoration: 'none' }}>datatilsynet.no</a>
            <a href="mailto:postkasse@datatilsynet.no" style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: '#3B6FD4', textDecoration: 'none' }}>postkasse@datatilsynet.no</a>
            <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: 'rgba(138,149,163,0.6)' }}>+47 74 07 70 00</span>
          </div>
        </div>
      </div>
      {/* Policy update notice */}
      <div
        style={{
          background: 'rgba(255,255,255,0.02)',
          border: '1px solid rgba(255,255,255,0.06)',
          borderLeft: '3px solid #F97316',
          padding: '24px 28px'
        }}
      >
        <div
          style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: '0.875rem',
            fontWeight: 700,
            color: '#F97316',
            marginBottom: '8px',
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
          }}
        >
          Endringer i denne erklæringen
        </div>
        <p
          style={{
            fontFamily: 'Georgia, serif',
            fontSize: '0.9375rem',
            color: 'rgba(238,240,242,0.65)',
            lineHeight: 1.7,
            margin: 0
          }}
        >
          Vi kan oppdatere denne personvernerklæringen fra tid til annen. Vesentlige endringer 
          vil bli varslet via e-post eller fremtredende melding på nettstedet minst 30 dager 
          før de trer i kraft. Siste oppdatering: <strong style={{ color: '#EEF0F2' }}>Februar 2026</strong>. 
          Versjon: <span style={{ fontFamily: 'JetBrains Mono, monospace', color: '#3B6FD4' }}>2.1.0</span>
        </p>
      </div>
    </section>
  );
};

export default PrivacyContactSection;
